import {
  getInteractiveVideo,
  listInteractiveService,
} from "../../../services/InteractiveVideoService";
import {
  INTERACTIVE_LOADING,
  LIST_INTERACTIVE,
  LOAD_INTERACTIVE,
  LOAD_INTERACTIVE_ERROR,
} from "../types";

export const getInteractiveAction = (id, isDemo) => (dispatch) => {
  dispatch({ type: INTERACTIVE_LOADING });

  return getInteractiveVideo(id, isDemo)
    .catch((e) =>
      dispatch({
        type: LOAD_INTERACTIVE_ERROR,
        payload: e,
      })
    )
    .then((d) => {
      if (d?.error) {
        return dispatch({
          type: LOAD_INTERACTIVE_ERROR,
          payload: d.error,
        });
      }
      dispatch({
        type: LOAD_INTERACTIVE,
        payload: d,
      });
    });
};

export const listInteractiveAction =
  ({ type, limit, page, scenarioId }) =>
  (dispatch) => {
    dispatch({ type: INTERACTIVE_LOADING });

    return listInteractiveService({ type, limit, page, scenarioId })
      .catch((e) =>
        dispatch({
          type: LOAD_INTERACTIVE_ERROR,
          payload: e,
        })
      )
      .then((d) => {
        if (d?.error) {
          return dispatch({
            type: LOAD_INTERACTIVE_ERROR,
            payload: d.error,
          });
        }
        
        dispatch({
          type: LIST_INTERACTIVE,
          payload: d,
        });
      });
  };
